import { FLOW_CONTROL_EMAIL_DAILY_LIMIT } from '@shared/workflow/flowControlEmailDailyLimit.js';

const TOOLTIP = `To protect deliverability, MindCloud sends at most ${FLOW_CONTROL_EMAIL_DAILY_LIMIT} workflow emails to a single recipient address per day. The limit resets at midnight UTC. Emails over the limit are skipped and not retried. This limit is enforced by MindCloud, so skipped emails will not appear in your email provider's logs.`;

const getFlowControlEmailRateLimitNotice = (outputData) => {
  const email = (Array.isArray(outputData) ? outputData : []).find((entry) => entry?.email?.rateLimitedRecipients?.length > 0)?.email;
  if (!email) {
    return null;
  }

  if (email.sent === false) {
    if (email.code !== 'RATE_LIMIT_EXCEEDED') {
      return null;
    }
    return {
      text: 'Email not sent — every recipient has reached the daily email limit.',
      tooltip: TOOLTIP
    };
  }

  const skippedCount = email.rateLimitedRecipients.length;
  return {
    text: `Email not sent to ${skippedCount} recipient${skippedCount === 1 ? '' : 's'} over the daily email limit.`,
    tooltip: TOOLTIP
  };
};

export default getFlowControlEmailRateLimitNotice;
